export const GET_RETURNS_REQUEST = "GET_RETURNS_REQUEST";
export const GET_RETURNS_SUCCESS = "GET_RETURNS_SUCCESS";
export const GET_RETURNS_FAILURE = "GET_RETURNS_FAILURE";

export const GET_DELETE_RETURNS_REQUEST = "GET_DELETE_RETURNS_REQUEST";
export const GET_DELETE_RETURNS_SUCCESS = "GET_DELETE_RETURNS_SUCCESS";
export const GET_DELETE_RETURNS_FAILURE = "GET_DELETE_RETURNS_FAILURE";


export const CREATE_RETURNS_REQUEST = "CREATE_RETURNS_REQUEST";
export const CREATE_RETURNS_SUCCESS = "CREATE_RETURNS_SUCCESS";
export const CREATE_RETURNS_FAILURE = "CREATE_RETURNS_FAILURE";

export const EDIT_RETURNS_REQUEST = "EDIT_RETURNS_REQUEST";
export const EDIT_RETURNS_SUCCESS = "EDIT_RETURNS_SUCCESS";
export const EDIT_RETURNS_FAILURE = "EDIT_RETURNS_FAILURE";

export const UPLOAD_RETURNS_REQUEST = "UPLOAD_RETURNS_REQUEST";
export const UPLOAD_RETURNS_SUCCESS = "UPLOAD_RETURNS_SUCCESS";
export const UPLOAD_RETURNS_FAILURE = "UPLOAD_RETURNS_FAILURE";

export const GET_REPAIR_REQUEST = "GET_REPAIR_REQUEST";
export const GET_REPAIR_SUCCESS = "GET_REPAIR_SUCCESS";
export const GET_REPAIR_FAILURE = "GET_REPAIR_FAILURE";
